import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260209_remove_roof_roof_system_id",
  description: "Remove roofSystemId from roofs in favor of parentId",
  apply(json: any): any {
    const roofs = json.roofs ?? {};
    for (const id of Object.keys(roofs)) {
      const roof = roofs[id];

      if (roof.roofSystemId && roof.parentId && roof.roofSystemId !== roof.parentId) {
        throw new Error(`Roof ${id} has roofSystemId ${roof.roofSystemId} but parentId ${roof.parentId}`);
      }

      if (roof.roofSystemId && !roof.parentId) {
        roof.parentId = roof.roofSystemId;
      }

      delete roof.roofSystemId;
    }
    return json;
  },
};

export default migration;
